
import { FC } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Users, Database, Lightbulb, Building, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import ActiveContributorsList from "@/components/profile/ActiveContributorsList";

interface Department {
  name: string;
  participants: number;
}

interface NetworkStats {
  totalParticipants: number;
  activeContributors: number;
  knowledgeBases: number;
  totalSolutions: number;
  departments: Department[];
}

interface KnowledgeNetworkStatsProps {
  stats: NetworkStats;
}

const KnowledgeNetworkStats: FC<KnowledgeNetworkStatsProps> = ({
  stats
}) => {
  const activePercentage = Math.round(stats.activeContributors / stats.totalParticipants * 100);
  return <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card className="p-4">
          <div className="flex flex-col items-center text-center">
            <Users className="h-8 w-8 text-blue-600 mb-2" />
            <h3 className="text-2xl font-bold">{stats.totalParticipants.toLocaleString()}</h3>
            <p className="text-sm text-gray-600">Total Participants</p>
          </div>
        </Card>
        
        <HoverCard>
          <HoverCardTrigger asChild>
            <Card className="p-4 cursor-pointer hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
              <div className="flex flex-col items-center text-center">
                <Users className="h-8 w-8 text-green-600 mb-2" />
                <h3 className="text-2xl font-bold">{stats.activeContributors.toLocaleString()}</h3>
                <p className="text-sm text-gray-600">Active Contributors</p>
              </div>
            </Card>
          </HoverCardTrigger>
          <HoverCardContent side="left" align="end" className="w-[600px] max-h-[600px] overflow-y-auto p-0">
            <ActiveContributorsList channelName="gsa" />
          </HoverCardContent>
        </HoverCard>
        
        <Card className="p-4">
          <div className="flex flex-col items-center text-center">
            <Database className="h-8 w-8 text-purple-600 mb-2" />
            <h3 className="text-2xl font-bold">{stats.knowledgeBases.toLocaleString()}</h3>
            <p className="text-sm text-gray-600">Knowledge Bases</p>
          </div>
        </Card>
        
        <Link 
          to="/channel-solutions?channel=gsa&demo=true"
          className="block"
        >
          <Card className="p-4 bg-black rounded-lg cursor-pointer hover:bg-gray-800 transition-all group">
            <div className="flex flex-col items-center text-center">
              <div className="relative">
                <Lightbulb className="h-8 w-8 text-white mb-2" />
                <ExternalLink className="h-4 w-4 absolute -right-3 -top-1 opacity-0 group-hover:opacity-100 transition-opacity text-white" />
              </div>
              <h3 className="text-2xl font-bold text-white">{stats.totalSolutions.toLocaleString()}</h3>
              <p className="text-sm text-white group-hover:font-medium transition-colors">Federal DEMO Marketplace</p>
            </div>
          </Card>
        </Link>
      </div>
      
    </div>;
};

export default KnowledgeNetworkStats;
